import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaMovimientos', NominasNominaMovimientos)

function NominasNominaMovimientos($http, $filter) {
  this.get = _get
  this.post = _post
  this.delete = _delete

  function _get(id_proyecto, id_nomina) {
    return $http.get('api/nominas/nomina/empleados', {
      params: {
        id_proyecto: id_proyecto,
        id_nomina: id_nomina,
      },
      schema: NominasNominaMovimientosSchema,
      cache: 'nominas',
    }).then(function (response) {
      response.data = $filter('orderBy')(response.data, ['cobro_carga_social', 'empleado'])

      return response
    })
  }

  function _post(id_proyecto, id_nomina, data) {
    return $http.post('api/nominas/nomina/empleados', data, {
      params: {
        id_proyecto: id_proyecto,
        id_nomina: id_nomina,
      },
      clearCache: 'nominas',
    })
  }

  function _delete(id_proyecto, id_nomina) {
    return $http.delete('api/nominas/nomina/empleados', {
      params: {
        id_proyecto: id_proyecto,
        id_nomina: id_nomina,
      },
      clearCache: 'nominas',
    })
  }
}

let NominasNominaMovimientosSchema = {
  status: 'boolean',
  status_calculado: 'boolean',
  importe: 'number',
  importe_divisa: 'number',
  tipo_cambio: 'number',
  comision_porcentaje: 'number',
  comision_importe: 'number',
  neto: 'number',
  total_percepciones: 'number',
  total_deducciones: 'number',
  neto_a_pagar: 'number',
  impuesto_estatal: 'number',
  carga_social: 'number',
  cobro_carga_social: 'boolean',
  config: {
    salario_diario: 'number',
  },
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Movimientos.js